import { Swiper } from "swiper/react";
import {Autoplay,Navigation, Pagination} from 'swiper/modules'

import "swiper/css";
import 'swiper/css/pagination';

export default ({ children, slidesPerView = 1, ...props }) => {
  return (
    <Swiper
      modules={[
        Autoplay,
        Navigation,
        Pagination
      ]}
      slidesPerView={slidesPerView}
      autoplay={true}
      spaceBetween={1}
      {...props}

    >
      {children}
    </Swiper>
  );
};